import ReducerCreator from '../registerReducer';
import * as TICKETS from './tickets.constants';
import { Ticket } from '../../models';
import { StoreItem } from '../Store';
import { APPLICATION_DISCONNECTED } from '../../stateManagement/application/application.constants';
import { copyStoreItemForId, buildLoadingStoreItemForId, buildStoreItemForId, buildErrorItemForId } from '../storeItemBuilder';

const r = new ReducerCreator<Ticket>()
    .register<Ticket[]>(TICKETS.TICKETS_LOAD, (state, payload) => {
        return buildLoadingStoreItemForId();
    })
    .register<Ticket[]>(TICKETS.TICKETS_LOAD_SUCCESS, (state, payload) => {
        return buildStoreItemForId(payload);
    })
    .register<Ticket[]>(TICKETS.TICKETS_ADD_SUCCESS, (state, payload) => {
        const newStoreItem = copyStoreItemForId(state.dictionary);
        // #33063: Don't include children tickets in store for now
        //payload.forEach(p => newStoreItem.dictionary[p.id] = p);
        payload.forEach(p => {
            if (!p.parentTicketId) {
                newStoreItem.dictionary[p.id] = p;
            }
        });
        return newStoreItem;
    })
    .register<Ticket[]>(TICKETS.TICKETS_UPDATE_SUCCESS, (state, payload) => {
        const newStoreItem = copyStoreItemForId(state.dictionary);
        // #33063: Don't include children tickets in store for now
        //payload.forEach(p => newStoreItem.dictionary[p.id] = p);
        payload.forEach(p => {
            if (!p.parentTicketId) {
                newStoreItem.dictionary[p.id] = p;
            }
        });
        return newStoreItem;
    })
    .register<any>(TICKETS.TICKETS_LOAD_ERROR, (state, reason) => {
        return buildErrorItemForId(reason);
    })
    .register<any>(TICKETS.TICKETS_ADD_ERROR, (state, reason) => {
        return buildErrorItemForId(reason);
    })
    .register<any>(TICKETS.TICKETS_UPDATE_ERROR, (state, reason) => {
        return buildErrorItemForId(reason);
    })
    .register<any>(TICKETS.TICKETS_DELETE_ERROR, (state, reason) => {
        return buildErrorItemForId(reason);
    })
    .register<Ticket[]>(APPLICATION_DISCONNECTED, (state, payload) => {
        return new StoreItem<Ticket>();
    });

export function ticketsReducer(state: StoreItem<Ticket> = new StoreItem<Ticket>(), action: { type: string, payload: any }) {
    return r.reduce(state, action);
}
